"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ActionTypes = require("./actionTypes");
const _treeAction = require("../tree/actions");
const _generatePreviewAction = require("../generatePreview/actions");
function default_1(namespace) {
    const _ActionTypes = ActionTypes.default(namespace);
    const treeActions = _treeAction.default(`preview-${namespace}`);
    const generatePreviewAction = _generatePreviewAction.default(`preview-${namespace}`);
    function setPreviewRevision(revision) {
        return {
            type: _ActionTypes.SET_PREVIEW_REVISION,
            revision
        };
    }
    return {
        setPreviewRevision,
        generatePreviewRequest: generatePreviewAction.generatePreviewRequest,
        generatePreviewFailure: generatePreviewAction.generatePreviewFailure,
        generatePreviewSuccess: generatePreviewAction.generatePreviewSuccess,
        treeActions
    };
}
exports.default = default_1;
//# sourceMappingURL=actions.js.map